/**
 * @generated SignedSource<<e77ea76df4beb00a3c30efbe8205b523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_issueTableHideDoneToggle_HideDoneItemsToggle_project">;
  readonly " $fragmentType": "topBar_issueNavigator_project";
};
export type topBar_issueNavigator_project$key = {
  readonly " $data"?: topBar_issueNavigator_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "55a62f7611991a65e32f4906894b8260";

export default node;
